import LTR from "@brand-icons/ploom/pin-store-negative/pin-store-negative-ltr.svg";

import { iconFactory } from "../iconFactory";

export const PinStoreNegativeIcon = iconFactory("PinStoreNegativeIcon", LTR);
